import { s3ImagesBaseURL } from "util/APIBaseUrl";

import { USER_TYPES } from "constants/index";

/**
 * Right-hand panel props for every screen built on the login Layout.
 *
 * Customers get their own artwork, which carries its own gradient and shows the
 * referral overlay instead of the Edge mark and "Match Your Ambition" caption.
 * Employees fall through to the Layout defaults.
 */
export interface LayoutImageProps {
  rightSideImage?: string;
  showReferralOverlay?: boolean;
}

export const getLayoutImageProps = (userType = ""): LayoutImageProps =>
  String(userType).toLowerCase() === USER_TYPES.CUSTOMER
    ? { rightSideImage: `${s3ImagesBaseURL}/customer-login-image.jpg`, showReferralOverlay: true }
    : {};

export default getLayoutImageProps;
